import { Roles } from "@/helpers/enums/Roles";
import axios from "axios";
import Swal from "sweetalert2";
import { store } from "../store";
import { JL } from "jsnlog";

const api = axios.create({
  baseURL: process.env.VUE_APP_AGSC_API,
});

JL.setOptions({
  defaultAjaxUrl: `${process.env.VUE_APP_AGSC_API}logging`,
});

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  api.defaults.headers.common["Authorization"] =
  "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6ImF0K2p3dCJ9.eyJpc3MiOiJodHRwczovL2xvY2FsaG9zdDo1MDAxIiwibmJmIjoxNzIzMTg1NjMxLCJpYXQiOjE3MjMxODU2MzEsImV4cCI6MTcyMzI3MjAzMSwiYXVkIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NTAwMS9yZXNvdXJjZXMiLCJzY29wZSI6WyJhcGkiLCJJZGVudGl0eVNlcnZlckFwaSJdLCJhbXIiOlsicHdkIl0sImNsaWVudF9pZCI6IlRFU1RFUiIsInN1YiI6Ijc1ODc1MGU1LTQ4MWEtNGVmMy1iZGQ1LTI5YzQ2MGY0NWIxNSIsImF1dGhfdGltZSI6MTcyMzE4NTYyOCwiaWRwIjoibG9jYWwiLCJuYW1lIjoiRnVya2FuIEFrZG_En2FuIiwiZ2l2ZW5fbmFtZSI6IkZ1cmthbiIsImZhbWlseV9uYW1lIjoiQWtkb8SfYW4iLCJyb2xlIjoiR2xvYmFsIEFkbWluIiwiZW1haWwiOiJmdXJrYW4uYS1leHRAYXBwZ3VhcmQudXMiLCJ1aWQiOiI3NTg3NTBlNS00ODFhLTRlZjMtYmRkNS0yOWM0NjBmNDViMTUiLCJQYXJ0bmVySWQiOiIiLCJqdGkiOiIyMkU1NzBFNTk3OEE5ODNGNTI4OEYzQUE3NDFFMEYxMiJ9.d43XEq964F_QibCtdDCBD9iS6GikRL8VbzoeSRHtAHXmE507Shva1XkQ-yXeD1vnHl44rBCyU53JLb9JpNqOnzKw3f3pD75CjkW5_bOfJrOPNPn1HBEPBRHRXYq0ypkzymeeMNHcL30U97jHtOU_oBNvKiaTxcT3yF-gwAIjGE1Y9up3Ebzb08EB-27HxFW5_YsUf5KGa3Zu47_t4ekGjBDdiWsV2ybImpKEHa5NChMUJSd_AeGronvIQbHK9hJZ13pmDuBq_8E5h_nW8RLSbqb47TIpmAMhgJ07L6yuOdfDUw6rWzMXyzeaHzNLQXvzm55mdqCxuaOVhCC1otwGOQ";
}

/*
api.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
api.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';
api.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
*/
//JSON.parse(sessionStorage.vuex).auth.company.companyGuid

// Add a request interceptor
api.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const company = localStorage.getItem("company");
    if (company) {
      const xCompanyGuid = company ? JSON.parse(company)?.companyGuid : "";
      config.headers.common["x-company-guid"] =
        typeof xCompanyGuid === "undefined" ? "" : xCompanyGuid;
  
      // partner
      const partner =
        localStorage.getItem("partner") == "undefined"
          ? ""
          : localStorage.getItem("partner");
      const xPartnerGuid = partner ? JSON.parse(partner)?.guid : "";
      config.headers.common["x-partner-guid"] =
        typeof xPartnerGuid === "undefined" ? "" : xPartnerGuid;
    
      // site
      const site =
        localStorage.getItem("site") == "undefined"
          ? ""
          : localStorage.getItem("site");
      const xSiteGuid = site ? JSON.parse(site)?.key : "";
      config.headers.common["x-site-guid"] =
        typeof xSiteGuid === "undefined" ? "" : xSiteGuid;
      
      // group
      const group =
        localStorage.getItem("group") == "undefined"
          ? ""
          : localStorage.getItem("group");
      const xGroupGuid = group ? JSON.parse(group)?.key : "";

      config.headers.common["x-group-guid"] =
        typeof xGroupGuid === "undefined" ? "" : xGroupGuid;
    }

    const partner = localStorage.getItem("partner");
    if(partner) {
      if(JSON.parse(partner)?.guid) {
        config.headers.common["x-partner-guid"] = JSON.parse(partner)?.guid;
      }
      if(JSON.parse(partner)?.id) {
        config.headers.common["x-partner-guid"] = JSON.parse(partner)?.id;
      }
    }else {
      config.headers.common["x-partner-guid"] = '';
    }

    if (
      localStorage.getItem("realRole") === Roles.AGMSAdmin &&
      store.getters.loggedInUser.role === Roles.AGMSAdmin
    ) {
      config.headers.common["x-partner-guid"] = "";
      config.headers.common["x-company-guid"] = "";
    }

    if (
      localStorage.getItem("realRole") === Roles.PartnerAdmin &&
      store.getters.loggedInUser.role === Roles.PartnerAdmin
    ) {
      config.headers.common["x-company-guid"] = "";
    }

    if (
      localStorage.getItem("realRole") === Roles.CompanyAdmin || 
      localStorage.getItem("realRole") === Roles.SiteAdmin ||
      localStorage.getItem("realRole") === Roles.GroupAdmin
    ) {
      const partnerId: any = (
        store.state.auth.user.find(f => f.type == "PartnerId") || {}
      ).value;
      if(partnerId) {
        config.headers.common["x-partner-guid"] = partnerId;
      }
    }

    if (
      config.url === "/Group/GetGroups" &&
      localStorage.getItem("withoutGroupHeader")
    ) {
      config.headers.common["x-group-guid"] = "";
    }
    if (
      config.url === "/Site/GetSites" &&
      localStorage.getItem("withoutSiteHeader")
    ) {
      config.headers.common["x-group-guid"] = "";
      config.headers.common["x-site-guid"] = "";
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log("response", response);
    return response;
  },
  function (error) {
    console.log("error", error);
    console.log("error", error.response);

    if (
      error &&
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.clear();
      sessionStorage.clear();
      const logoutUrl = `/bff/logout?sid=${
        store.getters.loggedInUser ? store.getters.loggedInUser.sid : ""
      }`;
      window.location.href = logoutUrl;
    } else {
      if (!process.env.NODE_ENV || process.env.NODE_ENV !== "development") {
        if(!error || Object.keys(error).length === 0 || !error.response) {
          return;
        }
        const errorData = {
          email: store.getters.loggedInUser
            ? store.getters.loggedInUser.email
            : "",
          exception: error.response,
          endpoint: window.location.pathname,
          browser: window.navigator.userAgent,
        };
        JL().error(errorData);
      }

      if (!document.querySelectorAll(".swal2-show").length) {
        if ([500, 400].indexOf(error.response.status) === -1) {
          let message = "Something went wrong! <br> Please refresh your page.";
          if (error.response.status == 404) {
            message = "Failed to send request.<br> The page sent the request returned a 404 response.<br> Please contact admin.";
          }
          if (error.response.status == 502) {
            message = "Failed to send request.<br> The page sent the request returned a 502 response.<br> The server may have down. <br>Please contact admin.";
          }
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: message,
            showCancelButton: true,
            cancelButtonText: 'Close',
            confirmButtonText: 'Reload Page',
            //footer: '<a href="/">HomePage</a>',
          }).then(function (result) {
            if(result.isConfirmed) {
              window.location.reload();
            }
          });
        }
      }
    }

    return Promise.reject(error);
  }
);

export default {
  api,
  errorHandler(error: Array<any>) {
    console.log(error);
  },
  get(url: string, params: any) {
    return api.get(url, params);
  },
  post(url: string, data: any, config: any = {}) {
    return api.post(url, data, config);
  },
  put(url: string, data: any) {
    return api.put(url, data);
  },
  delete(url: string) {
    return api.delete(url);
  },
};
